import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { VesselBuilderSelectListComponent } from '@components/vessel-builder-select-list/vessel-builder-select-list.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { TableLoadingComponent } from '@components/table-loading/table-loading.component';
import { AzureLoginPromptComponent } from '@components/azure-login-prompt/azure-login-prompt.component';

@Injectable({ providedIn: 'root' })
export class VesselBuilderSelectService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    overlayRef = this.overlay.create({
        hasBackdrop: true,
        minWidth: 500,
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    });

    constructor(
        public dialog: MatDialog,
        private overlay: Overlay,
        private toastr: ToastrService,
        private http: HttpClient,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async openBuilderSelectDialog() {
        if (!this.overlayRef.hasAttached()) {
            this.overlayRef.attach(new ComponentPortal(TableLoadingComponent));
        }
        try {
            const companyList = await this.getCompanyList();
            const builderList: BuilderData[] = this.getBuildersFromCompanies(companyList);

            this.overlayRef.detach();

            builderList.sort(this.compareForSort);

            const dialogRef = this.dialog.open(VesselBuilderSelectListComponent, {
                data: builderList,
            });

            const result = await lastValueFrom(dialogRef.afterClosed());

            return result;
        } catch (e) {
            if (e.status === HttpStatusCode.Forbidden) {
                this.overlayRef.detach();
                this.dialog.open(AzureLoginPromptComponent);
            } else {
                this.notifyError(e);
                this.overlayRef.detach();
                return;
            }
        }
    }

    private getCompanyList(): Promise<any> {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/company`, {
                headers: this.headers,
            }),
        );
    }

    private getBuildersFromCompanies(companyList: any) {
        const builderList = companyList.filter((element) => element.typeBuilder === 1);
        return builderList;
    }

    private compareForSort(vessel1: any, vessel2: any) {
        let r = 0;
        if (vessel1.name < vessel2.name) {
            r = -1;
        } else if (vessel1.name > vessel2.name) {
            r = 1;
        }

        return r;
    }

    public notifyError(error) {
        console.error(error);

        this.toastr.error(error.message, '', {
            timeOut: 3000,
            closeButton: true,
            disableTimeOut: true,
        });
    }
}

interface BuilderData {
    id: string;
    name: string;
}
